'use client';

import dynamic from 'next/dynamic';
import { useTranslations } from 'next-intl';
import ScrollRevealText from './ScrollRevealText';
import styles from './ImageSection.module.css';

// FloatingLines uses three.js + WebGL — must run client-side only
const FloatingLines = dynamic(() => import('./FloatingLines/FloatingLines'), {
  ssr: false,
});

const ImageSection = () => {
  const t = useTranslations('photon');

  return (
    <section className={styles.section}>
      <div className={styles.backgroundLayer} aria-hidden="true">
        <FloatingLines
          linesGradient={['#ff0000', '#ff0000', '#ff0000']}
          animationSpeed={1}
          interactive={false}
          bendRadius={9}
          bendStrength={-2}
          mouseDamping={0.05}
          parallax={false}
        />
      </div>
      <div className={styles.vignette} aria-hidden="true" />
      <div className={styles.textContainer}>
        <h2 className={styles.heading}>
          <span className={styles.line}>
            <ScrollRevealText
              text={t('photon.imageSection.heading.deeperRecovery')}
            />
          </span>{' '}
          <span className={styles.line}>
            <ScrollRevealText
              text={t('photon.imageSection.heading.protocolAttuned')}
            />
          </span>
        </h2>
      </div>
    </section>
  );
};

export default ImageSection;
